import { Modal } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import "./AdvanceFilterModal.scss";
import FilterIcon from "../../images/filters-image.svg";
import EnableCancelIcon from "../../images/Close_Blue_Icon.svg";
import DisableCancelIcon from "../../images/Close_Gray_Icon.svg";
import SearchIcon from "../../images/icon-search.svg";
import ArrowIcon from "../../images/new-slide-right-icon.svg";
import InfoIcon from "../../images/InfoBlackIcon.svg";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";

const AdvanceFilterModal = ({
  openAdvanceFilterModal,
  openAdvanceFilterHandler,
  countriesList,
  setCountriesList,
  brandsList,
  setBrandsList,
  mlrStatusList,
  setMLRStatusList,
  brandSelected,
  setBrandSelected,
  marketSelected,
  setMarketSelected,
  mlrSelected,
  setMlrSelected,
  setSelectedItems,
  selectedItems,
  setOpenAdvanceFilterModal,
  indicationList,
  indicationSelected,
  setIndicationSelected,
  getSearchCriteria,
  setCreatePresentationFields,
  createPresentationFields,
  createdbyMe,
  sendSearchDataToEdetails,
  totalCount,
  setTextSearch,
  setContentTypeSelected,
  contentTypeSelected,
  type
}) => {
  const [search, setSearch] = useState("");
  const [activeKey, setActiveKey] = useState("product");
  const [enableSearchCancelBtn, setEnableSearchCancelBtn] = useState(false);
  const [enableCancelBtn, setEnableCancelBtn] = useState(false);
  const [ enableSearchBtn, setEnableSearchBtn ] = useState(false);
  const [ filteredList, setFilteredList ] = useState(false);
  const ref = useRef(null);
  const [filterList, setFilterList] = useState([
    {
      name: "Product",
      key: "product",
    },
    {
      name: "Country",
      key: "country",
    },
    {
      name: "MLR status",
      key: "mlrStatus",
    },
    {
      name: "Indication",
      key: "indication",
    },
  ]);

  const [filteredData, setFilteredData] = useState({
    product: [],
    country: [],
    mlrStatus: [],
    indication: [],
    contentType: [],
  });

  useEffect(() => {
    if(search.length > 0) {
      setEnableSearchBtn(true);
      setEnableCancelBtn(true); 
      setEnableSearchCancelBtn(true);
    } else {
      setEnableSearchBtn(false);
      setEnableSearchCancelBtn(false);
      setFilteredList(false);
    }
  }, [search]);

  useEffect(() => {
    if(type === 2) {
      setFilterList(pre => [...pre, {
        name:"Content Type",
        key: "contentType",
      }])
    }
  }, [type]);

  const contentTypeList = [
    {name:"One-time content", value:"ONE_TIME_CONTENT"}, 
    {name:"Modular content", value:"MODULAR_CONTENT"}, 
    {name:"Auto-generated", value:"PDF_TO_HTML"},
  ]

  const selectedValue = (item, key) => {
    const flattened = selectedItems[key]?.flat() || [];
    return flattened.some(i => i.name === item.name);
  };

  const handleSelect = (item, key) => {
    setSelectedItems(prev => {
      const currentList = prev[key] || [];
      const isSelected = currentList.some(i => i.name === item.name);

      const updatedList = isSelected
        ? currentList.filter(i => i.name !== item.name)
        : [...currentList, item];

      return {
        ...prev,
        [key]: updatedList,
      };
    });
  };

  const productContent = (listType, listKey) => {
    return (
        <div className="advance-filter-options">
          {listType?.map((item) => (
            <div
              // className={`d-flex align-items-center active-filter-form-check ${selectedItems[listKey]?.some(li => li.name === item.name) ? 'filter-option-checked' : 'filter-option-unchecked'}`}
              className="d-flex align-items-center active-filter-form-check filter-option-unchecked"
              key={item.id}
            >
              <input
                className="form-check-input"
                type="checkbox"
                checked={selectedValue(item, listKey)}
                onChange={() => handleSelect(item, listKey)}
                id={`${listKey}-${item.name}`}
              />
              <label
                className="form-check-label"
                htmlFor={`${listKey}-${item.name}`}
              >
                {item?.name}
              </label>
            </div>
          ))}
          {
            listType && listType.length <= 0 && 
              <div className="d-flex align-items-center justify-content-center no-result-found">
                <img src={InfoIcon} alt="" width={11} height={11} />
                <span className="no-result-found-text1">No Result Found </span>
                <span className="no-result-found-text2">, try using different keywords</span>
              </div>
          }
        </div>
      );
  };

  const getListByKey = (key) => {
    switch (key) {
      case "product":
        return (enableSearchCancelBtn && filteredList) ? filteredData.product : brandsList;
      case "country":
        return (enableSearchCancelBtn && filteredList) ? filteredData.country :countriesList;
      case "mlrStatus":
        return (enableSearchCancelBtn && filteredList) ? filteredData.mlrStatus : mlrStatusList;
      case "indication":
        return (enableSearchCancelBtn && filteredList) ? filteredData.indication : indicationList;
      case "contentType":
        return (enableCancelBtn && filteredList) ? filteredData.contentType : contentTypeList;
      default:
        return undefined;
    }
  };

  const handleCancel = () => {
    if (search.length > 0) {
      setSearch("");
      setEnableSearchBtn(false);
      setEnableSearchCancelBtn(false);
    }
  };

  const applySelectedHandler = () => {
    const data = {
      ...createPresentationFields,
      skip: 0,
      limit: 100,
      created: createdbyMe,
      brand: selectedItems?.product?.map(i => i.id || i._id) || [],
      market: selectedItems?.country?.map(i => i.id || i._id) || [],
      mlrStatus: selectedItems?.mlrStatus?.map(i => i.name) || [],
      indication: selectedItems?.indication?.map(i => i.veevaid || i.veevaid) || [],
      contentType: selectedItems?.contentType?.map(i => i.value),
    };

    setBrandSelected(selectedItems?.product || []);
    setMarketSelected(selectedItems?.country || []);
    setMlrSelected(selectedItems?.mlrStatus || []);
    setIndicationSelected(selectedItems?.indication || []);
    setContentTypeSelected(selectedItems?.contentType || []);
    setCreatePresentationFields(prev => ({
      ...prev,
      ...data,
    }));

    sendSearchDataToEdetails(data, "search", "applyAll");
    setOpenAdvanceFilterModal(false);
  };

  const cancelSelectedHandler = () => {
    if (selectedItems?.product?.length > 0) {
      let selectedData;
      
      if(brandSelected?.length > selectedItems?.product) {
        selectedData = brandSelected?.filter(li => selectedItems?.product?.some(item => item.name === li.name))
      } else {
        selectedData = brandSelected;
      }
      setSelectedItems(prev => ({
        ...prev,
        product: selectedData
      }));
    }

    if (selectedItems?.country?.length > 0) {
      setSelectedItems(prev => ({
        ...prev,
        country: marketSelected?.filter(li => selectedItems?.country?.some(item => item.name === li.name))
      }));
    }

    if (selectedItems?.mlrStatus?.length > 0) {
      setSelectedItems(prev => ({
        ...prev,
        mlrStatus: mlrSelected?.filter(li => selectedItems?.mlrStatus?.some(item => item.name === li.name))
      }));
    }

    if (selectedItems?.indication?.length > 0) {
      setSelectedItems(prev => ({
        ...prev,
        indication: indicationSelected?.filter(li => selectedItems?.indication?.some(item => item.name === li.name))
      }));
    }

    if (selectedItems?.contentType?.length > 0) {
      setSelectedItems(prev => ({
        ...prev,
        contentType: contentTypeSelected?.filter(li =>
          selectedItems?.contentType?.some(item => item.name === li.name)
        )
      }));
    }
    openAdvanceFilterHandler(false);
  };

  const clearSelectedItem = () => {
    setSelectedItems({});
    setBrandSelected([]);
    setMarketSelected([]);
    setMlrSelected([]);
    setIndicationSelected([]);
    setContentTypeSelected([]);
    setSearch('');
    setEnableSearchBtn(false);
    if(brandSelected.length > 0 || marketSelected.length > 0 || mlrSelected.length > 0 || indicationSelected.length > 0 || contentTypeSelected.length > 0) {
      getSearchCriteria("", "reset");
    }
      // let data = {
      //   ...createPresentationFields,
      //   skip: 0,
      //   limit: 100,
      //   created: createdbyMe,
      // };
      // data["brand"] = "";
      // data["market"] = "";
      // data["mlrStatus"] = "";
      // data["indication"] = "";
      // data["searchInput"] = "";
      // setCreatePresentationFields({
      //   ...createPresentationFields,
      //   brand: [],
      //   market: [],
      //   mlrStatus: [],
      //   indication: [],
      //   searchInput: "",
      // });
      // setBrandSelected([]);
      // setMarketSelected([]);
      // setMlrSelected([]);
      // setIndicationSelected([]);
      // setTextSearch([]);
  }

  const handleTabSelect = (key) => {
    if (key !== activeKey) {
      setSearch("");
      setEnableSearchBtn(false);
      setEnableSearchCancelBtn(false);
    }
    setActiveKey(key);
  };

  const handleSearch = (key) => {
    if(search.length > 0 ) {
      setEnableSearchCancelBtn(true);
      setEnableSearchBtn(false);
      setEnableCancelBtn(true);
      setFilteredList(true);
    } else {
      // setEnableSearchCancelBtn(false);
      // setEnableSearchBtn(false);
      return;
    };
    if(key === 'product') {
      const product = brandsList?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase().trimEnd())
      );
      setFilteredData((prevData) => ({
        ...prevData,
        product: product,
      }));
    }
    if(key === 'country') {
      const country = countriesList?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredData((prevData) => ({
        ...prevData,
        country: country,
      }));
    }
    if(key === 'mlrStatus') {
      const mlrStatus = mlrStatusList?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredData((prevData) => ({
        ...prevData,
        mlrStatus: mlrStatus,
      }));
    }
    if(key === 'indication') {
      const indication = indicationList?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredData((prevData) => ({
        ...prevData,
        indication: indication,
      }));
    }
    if(key === "contentType") {
      const contentType = contentTypeList?.filter((item) => 
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredData((prevData) => ({
        ...prevData,
        contentType: contentType,
      }));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if(search?.length < 0) return;
      handleSearch(activeKey);
    }
  };

  const inputHandler = (e) => {
    const value = e.target.value.replace(/^\s+/, "");
    // console.log(value, 'vv')
    if(value?.length < 0) {
      setSearch('');
      return;
    };
    setSearch(value);
  }
    return (
    <Modal
      show={openAdvanceFilterModal}
      dialogClassName="advance-filter-main"
    >
      <Modal.Body className="advance-filter-body">
        <div className="filter-panel shadow rounded">
          <div className="d-flex justify-content-between align-items-center filterHeaderPanel">
            <div className="d-flex align-items-center">
              <img
                src={FilterIcon}
                alt="filter-icon"
                style={{ marginRight: "6px" }}
                width={15}
                height={16}
              />
              <h6 className="m-0">Filters {totalCount !== 0 && `(${totalCount})`}</h6>
            </div>
            <button onClick={() => clearSelectedItem()} disabled={totalCount === 0} className={`btn btn-link btn-sm text-decoration-none filter-clear-btn ${totalCount > 0 ? 'enabled-clear-btn' : 'desabled-clear-btn'}`}>
              Clear all
            </button>
          </div>

          <div className="d-flex" style={{ height: "360px" }}>
            <Tab.Container id="left-tabs-example" activeKey={activeKey} onSelect={handleTabSelect}>
              <Row className="m-0">
                <div
                  className="nav flex-column border-end filterLeftPanel"
                  style={{ width: "200px" }}
                >
                  <Nav variant="pills" className="flex-column">
                    {filterList.map((list) => {
                      return (
                      <Nav.Item key={list.key}>
                        <Nav.Link eventKey={list?.key} className="d-flex justify-content-between align-items-center"> 
                          {list?.name} {selectedItems[list.key]?.length > 0 && `(${selectedItems[list.key]?.length})`}
                          <img src={ArrowIcon} alt="arrow-img" width={10} height={7} style={{marginRight: '12px'}}/>
                        </Nav.Link>
                      </Nav.Item>
                    )
                    })}
                  </Nav>
                </div>
                <div
                  className="filterRightPanel"
                  style={{ width: "349px", padding: "16px 20px 0px 20px" }}
                >
                  <Tab.Content>
                    <div
                      ref={ref}
                      style={{ position: "relative" }}
                      className={`filter-search-field${enableSearchCancelBtn ? " filter-search-field-active" : ""}`}
                    >
                      <img
                        src={SearchIcon}
                        className="search-icon"
                        alt="search"
                      />
                      <input
                        type="text"
                        className="form-control filter-input-field mb-3"
                        placeholder="Search by Name"
                        value={search}
                        onFocus={() => setEnableSearchCancelBtn(true)}
                        onChange={(e) => inputHandler(e)}
                        onKeyDown={(e) => handleKeyPress(e, activeKey)}
                      />
                      {enableSearchCancelBtn  && (
                        <div className="d-flex align-items-center filter-search-btn">
                          <button
                            disabled={enableSearchBtn ? false : true}
                            className={`search-btn ${
                              enableSearchBtn ? "search-btn-enabled" : "search-btn-desabled"
                            }`}
                            onClick={(e) => handleSearch(activeKey)}
                          >
                            Search
                          </button>
                          <img
                            src={enableCancelBtn ? EnableCancelIcon : DisableCancelIcon}
                            className={`cancel-icon ${enableCancelBtn ? "enable-cancel-btn" : "desable-search-btn"}`}
                            alt="cancel"
                            width={20}
                            height={20}
                            onClick={() => handleCancel()}
                          />
                        </div>
                      )}
                    </div>
                    {filterList && filterList.map((filter) => (
                      <Tab.Pane key={filter.key} eventKey={filter.key}>
                        {productContent(getListByKey(filter.key), filter.key)}
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </div>
              </Row>
            </Tab.Container>
          </div>
          <div className="d-flex justify-content-end filterFooterPanel">
            <button
              className="filter-cancel-btn"
              onClick={() => cancelSelectedHandler()}
            >
              CANCEL
            </button>
            <button
              className={`filter-apply-btn ${totalCount === 0 ? "desabled-apply-btn" : "enabled-apply-btn"}`}
              disabled={totalCount === 0}
              onClick={() => applySelectedHandler()}
            >
              APPLY
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AdvanceFilterModal;
